import type { IconName } from '@fortawesome/fontawesome-svg-core';
import React from 'react';

import Icon from '@components/Icon/Icon';
import Image from '@components/Image';

import { ProfileImg, ViewingIcon } from './ProfileBubble.style';

interface ProfileBubbleProps {
  fallback?: IconName;
  s3Key?: string | null;
  size?: number;
  viewing?: boolean;
  plain?: boolean;
  loading?: boolean;
  style?: React.CSSProperties;
}

export const ProfileBubble = React.forwardRef<
  HTMLDivElement,
  ProfileBubbleProps
>(
  (
    {
      fallback = 'circle-user',
      s3Key,
      size = 45,
      viewing = false,
      plain = false,
      loading = false,
      style,
      ...rest
    },
    ref
  ) => {
    return (
      <ProfileImg
        plain={plain}
        size={size}
        {...rest}
        ref={ref}
        style={{ ...style }}
      >
        <Image
          alt=""
          cssStyle={{
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            fontSize: `${size}px`,
            lineHeight: `${size}px`,
            ...style,
          }}
          fallback={fallback}
          height={size}
          loading={loading}
          s3_key={s3Key}
          width={size}
        />
        {viewing ? (
          <ViewingIcon data-testid="profile-bubble-viewed">
            <Icon color="primary.main" name="eye" />
          </ViewingIcon>
        ) : null}
        {/* {notification ? (
        <NotificationIcon data-testid="profile-bubble-notification" />
      ) : null} */}
      </ProfileImg>
    );
  }
);

export default ProfileBubble;
